// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__D7c9J","title":"Home_title__iwdVI","content":"Home_content__U37Cq"};